import { getVariable } from 'helpers/environment.utils';

export const useGetAccessToken = () => {
  const AWS_CLIENT_ID = getVariable('REACT_APP_ENV_AWS_CLIENT_ID');

  const userId = localStorage.getItem('user-store')
    ? JSON.parse(localStorage.getItem('user-store')!).state.authUser
      ? JSON.parse(localStorage.getItem('user-store')!).state.authUser.id
      : undefined
    : undefined;

  const storageItem = 'CognitoIdentityServiceProvider.' + AWS_CLIENT_ID + '.' + userId + '.accessToken';
  const accessToken = localStorage.getItem(storageItem);

  return accessToken;
};
